import React from "react";

const CommonInput = ({ register, name, errors, type = "text", disabled = false, placeholder = "" }) => {
  return (
    <>
      <input
        {...register(name)}
        type={type}
        className="form-control bg-light"
        disabled={disabled}
        placeholder={placeholder}
      />
      {
        <p className="errorColor">
          {errors?.[name] && errors?.[name]?.message}
        </p>
      }
    </>
  );
};

export default CommonInput;
